import get from "lodash/get";
import { REHYDRATE } from "redux-persist";
import { handleActions } from "../../utils/redux-utils";

import {
  RECEIVE_APPCONFIG,
  RECEIVE_APPCONFIG_SUCCESS,
  RECEIVE_APPCONFIG_FAIL,
  UPDATE_PROSPECT_ID,
  REMOVE_PROSPECT_ID,
  SET_CONFIG,
  SET_PROSPECT,
  SAVE_SIGNATORY_MODEL,
  SAVE_RO_SIGNATORY_MODEL,
  SET_ACCESS_TOKEN,
  RESET_PROSPECT,
  RESET_RO_PROSPECT,
  RESET_APPLICANT_INFO,
  SET_PROSPECT_LEAD,
  SET_EXPIRED,
  SET_RO_CODE,
  UPDATE_APPLICATION_STATUS,
  RESET_REJECT_REASON,
  UPDATE_EXISTING_CUSTOMER,
  UPDATE_SUB_SOURCE,
  SET_SCREENING_RESULTS,
  RECEIVE_DATALIST_SEARCH,
  RECEIVE_DATALIST_SEARCH_SUCCESS,
  RECEIVE_DATALIST_SEARCH_FAIL
} from "../actions/appConfig";
import { LOGIN_INFO_FORM_SUCCESS, LOGOUT } from "../actions/loginForm";
import { UAE_CODE } from "../../constants";

export const initialState = {
  loading: false,
  uiConfig: {},
  prospect: {
    applicationInfo: {
      islamicBanking: false
    }
  },
  roProspect: {},
  dataList: {},
  error: "",
  prospectError: false,
  searchInfo: { segment: "sme" },
  login: {},
  signatoryModel: {},
  applicationStatus: {}
};

export default handleActions(
  {
    [REHYDRATE]: (state, action) => ({
      ...state,
      prospect: get(action, "payload.appConfig.prospect", state.prospect)
    }),
    [RECEIVE_APPCONFIG]: state => ({
      ...state,
      loading: true,
      error: ""
    }),
    [RECEIVE_APPCONFIG_SUCCESS]: (state, action) => ({
      ...state,
      ...action.payload,
      loading: false
    }),
    [LOGIN_INFO_FORM_SUCCESS]: (state, action) => ({
      ...state,
      authorizationToken: get(action, "payload.access_token", state.authorizationToken)
    }),
    [LOGOUT]: state => ({
      ...state,
      login: {
        userName: "",
        password: ""
      },
      searchInfo: {
        ...state.searchInfo,
        fullName: "",
        countryCode: UAE_CODE,
        mobileNo: "",
        leadNumber: "",
        tradeLicenseNo: "",
        email: ""
      },
      prospect: {}
    }),
     [SET_ACCESS_TOKEN]: (state, action) => ({
      ...state,
      authorizationToken: action.payload.accessToken,
      refreshToken: action.payload.refreshToken
    }),
    [RECEIVE_APPCONFIG_FAIL]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload || "error"
    }),
    [SET_CONFIG]: (state, action) => ({
      ...state,
      ...action.payload
    }),
    [SET_PROSPECT]: (state, action) => ({
      ...state,
      prospect: action.payload
    }),
    [RESET_PROSPECT]: state => ({
      ...state,
      prospect: initialState.prospect
    }),
    [RESET_RO_PROSPECT]: (state, action) => ({
      ...state,
      roProspect: action.payload
    }),
    [UPDATE_PROSPECT_ID]: (state, action) => ({
      ...state,
      prospect: {
        ...state.prospect,
        generalInfo: {
          ...get(state, "prospect.generalInfo", {}),
          prospectId: action.payload
        }
      }
    }),
    [REMOVE_PROSPECT_ID]: state => ({
      ...state,
      prospect: {
        ...state.prospect,
        generalInfo: {
          ...get(state, "prospect.generalInfo", {}),
          prospectId: ""
        }
      }
    }),
    [SAVE_SIGNATORY_MODEL]: (state, action) => ({
      ...state,
      signatoryModel: action.payload
    }),
    [SAVE_RO_SIGNATORY_MODEL]: (state, action) => ({
      ...state,
      roSignatoryModel: action.payload
    }),
    [RESET_APPLICANT_INFO]: state => ({
      ...state,
      authorizationToken: null,
      prospect: {
        ...state.prospect,
        applicantInfo: {
          fullName: "",
          email: "",
          countryCode: UAE_CODE,
          mobileNo: ""
        }
      }
    }),
    [SET_PROSPECT_LEAD]: (state, action) => ({
      ...state,
      leadSource: action.payload
    }),
    [SET_EXPIRED]: (state, action) => ({
      ...state,
      expired: action.payload
    }),
    [SET_RO_CODE]: (state, action) => ({
      ...state,
      roCode: action.payload
    }),
    [UPDATE_APPLICATION_STATUS]: (state, action) => ({
      ...state,
      applicationStatus: action.payload
    }),
    [RESET_REJECT_REASON]: (state, action) => ({
      ...state,
      roProspect: {
        ...state.roProspect,
        preliminaryCriteria: {
          ...state.roProspect.preliminaryCriteria,
          rejectReason: "",
          reasonfreeText: ""
        }
      }
    }),
    [UPDATE_EXISTING_CUSTOMER]: (state, action) => ({
      ...state,
      prospect: {
        ...state.prospect,
        applicationInfo: {
          ...state.prospect.applicationInfo,
          existingCustomer: action.payload
        }
      }
    }),
    [UPDATE_SUB_SOURCE]: (state, action) => ({
      ...state,
      prospect: {
        ...state.prospect,
        applicationInfo: {
          ...state.prospect.applicationInfo,
          subSource: action.payload
        }
      }
    }),
    [SET_SCREENING_RESULTS]: (state, action) => ({
      ...state,
      prospect: {
        ...state.prospect,
        organizationInfo: {
          ...state.prospect.organizationInfo,
          screeningInfo: action.payload
        }
      }
    }),
    [RECEIVE_DATALIST_SEARCH]: state => ({
      ...state,
      loading: true
    }),
    [RECEIVE_DATALIST_SEARCH_SUCCESS]: (state, action) => ({
      ...state,
      ...action.payload,
      loading: false
    }),
    [RECEIVE_DATALIST_SEARCH_FAIL]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload || "error"
    })
  },
  initialState
);
